import React, { useState, useEffect, useMemo } from 'react';
import { 
  LayoutDashboard, Users, Package, FileText, Settings as SettingsIcon, Plus, Search, Trash2, 
  Save, X, Mail, Phone, DollarSign, ChevronLeft, Filter, Upload, Edit, Download, Database, 
  RefreshCw, Globe, User, CheckCircle, Send, ArrowLeft, ArrowRight, BarChart3, LogOut, Shield, 
  Cloud, FileSpreadsheet, Loader, Copy, Sun, Moon, MessageCircle, FileX, Bell, Clock, 
  AlertCircle, Check, MapPin, Hash, UserCheck, Smartphone, Tag
} from 'lucide-react';
import { THEMES, HOSTINGER_API_URL, CATEGORY_SORT_ORDER, DEFAULT_CATEGORIES, DEFAULT_TERMS, COMPANY_INFO, STATUS_OPTIONS } from '../config/constants';
import { apiCall } from '../services/api';

const Card = ({ children, className = "", theme }) => (
  <div className={`rounded-2xl ${THEMES[theme].card} ${className}`}>
    {children}
  </div>
);

export default Card;
